import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { Floorplan } from "@domain/project/floorplan/floorplan";
import { requireScopedProject } from "@domain/project/project-deserializer";
import { ProjectFloorplanService } from "@domain/project/project-floorplan.service";
import { Observable, catchError, map, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FloorplanResolver {
  private router = inject(Router);
  private projectFloorplanService = inject(ProjectFloorplanService);

  resolve(route: ActivatedRouteSnapshot): Observable<Floorplan | undefined> {
    const project = requireScopedProject(route.parent?.data["project"]);
    const floorplanId = route.params["floorplanId"];

    const cached = this.projectFloorplanService.floorplans.find((f) => f.id === floorplanId);

    if (cached) {
      return of(cached);
    }

    // fallback: not yet in cache, load from IndexedDB and init
    return this.projectFloorplanService.getFloorplanFromIndexedDB(floorplanId).pipe(
      map((floorplan) => {
        floorplan.init(project, (f, type, subject) => this.projectFloorplanService.publishFloorplanEvent(f, type, subject));
        return floorplan;
      }),
      catchError(() => {
        this.router.navigate([`/projects/${route.parent?.params["id"]}`]);
        return of(undefined);
      }),
    );
  }
}
